import { normalizeLanguageCode } from './language-util';

// ----------------------------------------------------------------------

const FONT_URLS: Record<string, string> = {
  ar: 'https://fonts.googleapis.com/css2?family=Noto+Naskh+Arabic:wght@400;500;600;700&display=swap',
  bn: 'https://fonts.googleapis.com/css2?family=Hind+Siliguri:wght@400;500;600;700&display=swap',
  'zh-CN':
    'https://fonts.googleapis.com/css2?family=Noto+Sans+SC:wght@400;500;600;700&display=swap',
  'zh-TW':
    'https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@400;500;600;700&display=swap',
  he: 'https://fonts.googleapis.com/css2?family=Noto+Sans+Hebrew:wght@400;500;600;700&display=swap',
  ne: 'https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;500;600;700&display=swap',
  hi: 'https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;500;600;700&display=swap',
  th: 'https://fonts.googleapis.com/css2?family=Noto+Sans+Thai:wght@400;500;600;700&display=swap',
  tr: 'https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;500;600;700&display=swap',
  km: 'https://fonts.googleapis.com/css2?family=Noto+Sans+Khmer:wght@400;500;600;700&display=swap',
};

const loadedFonts = new Set<string>();

/**
 * 특정 언어의 폰트를 동적으로 로드합니다
 * @param lang 언어 코드 (예: 'ar', 'zh-CN')
 * @returns Promise<void>
 */
export async function loadFontForLanguage(lang: string): Promise<void> {
  const normalizedLang = normalizeLanguageCode(lang);
  const fontUrl = FONT_URLS[lang] || FONT_URLS[normalizedLang];

  if (!fontUrl || loadedFonts.has(lang)) {
    return; // 이미 로드되었거나 지원하지 않는 언어
  }

  try {
    // 폰트 CSS 로드
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = fontUrl;

    // 로드 완료를 기다림
    await new Promise<void>((resolve, reject) => {
      link.onload = () => resolve();
      link.onerror = () => reject(new Error(`Failed to load font: ${fontUrl}`));
      document.head.appendChild(link);
    });

    loadedFonts.add(lang);
    console.log(`Font loaded for language: ${lang}`);
  } catch (error) {
    console.warn(`Failed to load font for language ${lang}:`, error);
  }
}

/**
 * 여러 언어의 폰트를 동시에 로드합니다
 * @param langs 언어 코드 배열
 * @returns Promise<void>
 */
export async function loadFontsForLanguages(langs: string[]): Promise<void> {
  await Promise.all(langs.map(loadFontForLanguage));
}

/**
 * 로드된 폰트 목록을 반환합니다
 * @returns Set<string>
 */
export function getLoadedFonts(): Set<string> {
  return new Set(loadedFonts);
}
